/**
 * React hook for TanStack Store integration
 */

import { useStore } from "@tanstack/react-store";
import { type RampsState, rampsActions, rampsStore } from "./ramps-store";

export function useRampsStore<TSelected = RampsState>(
	selector?: (state: RampsState) => TSelected,
) {
	return useStore(rampsStore, selector);
}

// Export actions for easy access
export { rampsActions };

// Export types
export type { RampsState };
